import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

const NeedUpdateCheckAmount = () => (
  <Stack
    aria-label="Need update check amount"
    gap="8px"
    pb="64px"
  >
    <Box>
      <Text
        color="tertiary"
        size="md"
      >
        The check amount could not be confirmed. Please re-enter amount in US dollars.
      </Text>
    </Box>
    <Box>
      <Text
        color="tertiary"
        size="md"
      >
        Daily deposit limit: $10,000
      </Text>
      <Text
        color="tertiary"
        size="md"
      >
        Monthly deposit limit: $100,000
      </Text>
    </Box>
  </Stack>
);

export default NeedUpdateCheckAmount;
